import { render } from "./plus.vue?vue&type=template&id=b42912a4"
import script from "./plus.vue?vue&type=script&lang=js"
export * from "./plus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__